<template>
  <div>
    <el-alert
      title="入库确认会生成并审核采购入库单。弃审回冲会冲回库存并删除该入库单，再到货单回到草稿。批次可手填，库位随明细保存。"
      type="info" :closable="false" show-icon style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-input v-model="query.arrivalCode" clearable placeholder="到货单号" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.supplierName" clearable placeholder="供应商" style="width:160px" @keyup.enter.native="search" />
      <el-select v-model="query.arrivalState" clearable placeholder="状态" style="width:120px">
        <el-option label="草稿" value="00" />
        <el-option label="已入库" value="01" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
    </div>
    <el-table :data="list" border v-loading="loading">
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="arrivalCode" label="到货单号" width="200" />
      <el-table-column prop="supplierName" label="供应商" min-width="140" show-overflow-tooltip />
      <el-table-column prop="arrivalDate" label="到货日期" width="120" />
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="row.arrivalState === '01' ? 'success' : 'info'">{{ row.arrivalState === '01' ? '已入库' : '草稿' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="250" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" :disabled="row.arrivalState !== '00'" @click="openEdit(row.arrivalId)">修改</el-button>
          <el-button type="text" :disabled="row.arrivalState !== '00'" @click="acceptRow(row.arrivalId)">入库确认</el-button>
          <el-button type="text" :disabled="row.arrivalState !== '01'" @click="unacceptRow(row.arrivalId)">弃审回冲</el-button>
          <el-button type="text" style="color:#ef4444" :disabled="row.arrivalState !== '00'" @click="onDelete(row.arrivalId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage" @size-change="onSize"
    />

    <el-dialog :title="form.arrivalId ? '修改到货单' : '新增到货单'" :visible.sync="visible" width="980px" :close-on-click-modal="false">
      <el-form :model="form" label-width="90px">
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="到货单号"><el-input v-model="form.arrivalCode" placeholder="留空自动生成" /></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="到货日期">
              <el-date-picker v-model="form.arrivalDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="供应商" required>
              <el-select v-model="form.supplierId" filterable clearable placeholder="请选择供应商" style="width:100%">
                <el-option v-for="c in companies" :key="c.companyId" :label="(c.companyNumber ? c.companyNumber + ' / ' : '') + c.companyName" :value="c.companyId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item>
          </el-col>
        </el-row>
        <el-button type="primary" size="mini" style="margin-bottom:8px" @click="addLine">添加物料</el-button>
        <el-table :data="form.lines" border size="small">
          <el-table-column label="物料" min-width="220">
            <template slot-scope="{ row }">
              <el-select v-model="row.productId" filterable placeholder="选择物料" style="width:100%">
                <el-option v-for="p in products" :key="p.productId" :label="(p.productNumber || '') + ' / ' + (p.productName || '')" :value="p.productId" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="仓库" width="180">
            <template slot-scope="{ row }">
              <el-select v-model="row.wareHouseId" filterable placeholder="入库仓" style="width:100%">
                <el-option v-for="w in warehouses" :key="w.wareHouseId" :label="w.wareHouseName" :value="w.wareHouseId" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="批次" width="120">
            <template slot-scope="{ row }"><el-input v-model="row.batchNo" placeholder="可选" /></template>
          </el-table-column>
          <el-table-column label="数量" width="140">
            <template slot-scope="{ row }">
              <el-input-number v-model="row.quantity" :min="0" :precision="4" style="width:100%" />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="70" align="center">
            <template slot-scope="{ $index }"><el-button type="text" @click="form.lines.splice($index, 1)">删除</el-button></template>
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import {
  listPurchaseDelivery, getPurchaseDelivery, savePurchaseDelivery, updatePurchaseDelivery,
  deletePurchaseDelivery, acceptPurchaseDelivery, unacceptPurchaseDelivery
} from '../../api/purchaseDelivery'
import { selectProduct } from '../../api/product'
import { selectCompany } from '../../api/staff'
import { selectEnabledWareHouse } from '../../api/warehouse'

export default {
  components: { ListPagination },
  data() {
    return {
      query: { arrivalCode: '', supplierName: '', arrivalState: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false,
      visible: false, saving: false,
      form: { arrivalId: '', arrivalCode: '', supplierId: '', arrivalDate: '', remark: '', lines: [{ productId: '', wareHouseId: '', batchNo: '', quantity: 1 }] },
      products: [], companies: [], warehouses: []
    }
  },
  created() {
    this.load()
    selectProduct().then(res => { this.products = res.data || [] }).catch(() => {})
    selectCompany().then(res => { this.companies = res.data || [] }).catch(() => {})
    selectEnabledWareHouse().then(res => { this.warehouses = res.data || [] }).catch(() => {})
  },
  methods: {
    emptyForm() {
      return { arrivalId: '', arrivalCode: '', supplierId: '', arrivalDate: '', remark: '', lines: [this.emptyLine()] }
    },
    emptyLine() {
      return { productId: '', wareHouseId: '', batchNo: '', quantity: 1 }
    },
    indexMethod(i) { return (this.page - 1) * this.pageSize + i + 1 },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listPurchaseDelivery({
        currentPage: this.page, pageSize: this.pageSize,
        arrivalCode: this.query.arrivalCode,
        supplierName: this.query.supplierName,
        arrivalState: this.query.arrivalState
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    addLine() { this.form.lines.push(this.emptyLine()) },
    openEdit(id) {
      if (!id) {
        this.form = this.emptyForm()
        this.visible = true
        return
      }
      getPurchaseDelivery(id).then(res => {
        const d = res.data || {}
        this.form = {
          arrivalId: d.arrivalId,
          arrivalCode: d.arrivalCode,
          supplierId: d.supplierId || '',
          arrivalDate: d.arrivalDate,
          remark: d.remark,
          lines: (d.lines && d.lines.length) ? d.lines.map(l => ({
            productId: l.productId, wareHouseId: l.wareHouseId, batchNo: l.batchNo, quantity: Number(l.quantity)
          })) : [this.emptyLine()]
        }
        this.visible = true
      })
    },
    submit() {
      if (!this.form.supplierId) {
        this.$message.warning('请选择供应商')
        return
      }
      const lines = (this.form.lines || []).filter(l => l.productId && Number(l.quantity) > 0)
      if (!lines.length) {
        this.$message.warning('请添加到货明细')
        return
      }
      if (lines.some(l => !l.wareHouseId)) {
        this.$message.warning('请选择入库仓库')
        return
      }
      this.saving = true
      const payload = { ...this.form, lines }
      const req = this.form.arrivalId ? updatePurchaseDelivery(payload) : savePurchaseDelivery(payload)
      req.then(() => {
        this.$message.success('保存成功')
        this.visible = false
        this.search()
      }).finally(() => { this.saving = false })
    },
    acceptRow(id) {
      this.$confirm('确认到货入库并增加库存？', '提示', { type: 'warning' }).then(() => {
        acceptPurchaseDelivery(id).then(() => {
          this.$message.success('操作成功')
          this.load()
        })
      }).catch(() => {})
    },
    unacceptRow(id) {
      this.$confirm('确认弃审并回冲库存？自动生成的采购入库单会一并删除。', '提示', { type: 'warning' }).then(() => {
        unacceptPurchaseDelivery(id).then(() => {
          this.$message.success('操作成功')
          this.load()
        })
      }).catch(() => {})
    },
    onDelete(id) {
      this.$confirm('确定删除？', '提示', { type: 'warning' }).then(() => {
        deletePurchaseDelivery([id]).then(() => {
          this.$message.success('操作成功')
          this.load()
        })
      }).catch(() => {})
    }
  }
}
</script>
